import { cn } from "@/lib/utils";

export type MissionStatus = "me-viro" | "quase" | "ainda-nao";

const COPY: Record<MissionStatus, string> = {
  "me-viro": "Me viro",
  quase: "Quase",
  "ainda-nao": "Ainda não",
};

const TEXT: Record<MissionStatus, string> = {
  "me-viro": "text-blue-600",
  quase: "text-orange-700",
  "ainda-nao": "text-neutral-500",
};

const DOT: Record<MissionStatus, string> = {
  "me-viro": "bg-blue-600",
  quase: "bg-orange-500",
  "ainda-nao": "bg-neutral-400",
};

export const StatusDot = ({
  status,
  className,
}: {
  status: MissionStatus;
  className?: string;
}) => (
  <span className={cn("inline-flex items-center gap-1.5 text-label", TEXT[status], className)}>
    <span className={cn("h-2 w-2 rounded-full", DOT[status])} />
    {COPY[status]}
  </span>
);
